<template functional>
  <vx-card
    title="จำนวนนิสิตในแต่ละหน่วยการเรียน" subtitle=" '"
    style="min-height: 400px;"
  >
    <template slot="actions">
      <div>
        <span>เลือกชุดข้อมูลเปรียบเทียบ</span>
      </div>
    </template>

    <div slot="no-body" class="p-4">
      
      <!-- Loader -->
      <div v-if="props.updating" class="loader w-full">
        <component name="student-each-unit-loader" :is="injections.components.Loader" />
      </div>

      <div v-else>
        <component :is="injections.components.VueApexCharts"
          type="area" :height="props.height" width='100%'
          :series="props.chartSeries"
          :options="props.chartOptions" />
      </div>
    </div>
  </vx-card>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import Loader from "@/components/common-ui/loader-block";

export default {
  inject: {
    components: {
      default: {
        VueApexCharts,
        Loader
      }
    },
  },
  props: {
    updating: {
      type: Boolean, default: true
    },
    chartOptions: {
      type: Object, default: null,
    },
    chartSeries: {
      type: Array, default: () => ([]),
    },
    height: {
      type: Number, default: 385
    }
  }
}
</script>
